/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum PositionReservedType {
  Reserved = "Reserved",
  NotReserved = "Not Reserved",
}

export const PositionReservedTypeDisplay: Record<PositionReservedType, string> = {
  [PositionReservedType.Reserved]: "Reserved",
  [PositionReservedType.NotReserved]: "Not Reserved",
};
